import * as types from './types';

export const resetState = () => ({
  type: types.USER_SIGN_IN_RESET_STATE
});

export const setSignInEmail = (signInEmail) => ({
  type: types.USER_SIGN_IN_SET_SIGN_IN_EMAIL,
  signInEmail
});



// WEBPACK FOOTER //
// ./src/actions/user-sign-in/index.js